import React from 'react';
import { Link } from 'react-router-dom';
import Page from '../components/Layout/Page';

export default function MentionsLegalesPage() {
  return (
    <Page largeur="etroite" titre="Mentions légales" chapeau="Informations légales et d’exploitation de ZENKART.">
      <div className="zk-texte">
        <h2>1. Éditeur du site</h2>
        <p>
          <strong>Entreprise :</strong> FAYE Saliou (Williams), Entrepreneur Individuel<br />
          <strong>Adresse :</strong> 33440 Ambarès-et-Lagrave<br />
          <strong>RCS Bordeaux :</strong> 939 002 762<br />
          <strong>Régime fiscal :</strong> TVA non applicable, article 293 B du CGI<br />
          <strong>Contact :</strong> contact@zenkart.fr<br />
          <strong>Directeur de publication :</strong> FAYE Saliou
        </p>

        <h2>2. Hébergeur</h2>
        <p>
          <strong>Entreprise :</strong> Hetzner Online GmbH<br />
          <strong>Adresse :</strong> Industriestr. 25, 91710 Gunzenhausen, Allemagne<br />
          <strong>Site web :</strong> <a href="https://www.hetzner.com" target="_blank" rel="noreferrer">www.hetzner.com</a>
        </p>

        <h2>3. Propriété intellectuelle</h2>
        <p>
          L’ensemble du contenu du site ZENKART (textes, images, logos, codes sources, données) est la propriété
          exclusive de FAYE Saliou ou de ses partenaires. Toute reproduction, distribution, modification ou
          utilisation sans autorisation préalable écrite est interdite.
        </p>

        <h2>4. Limitation de responsabilité</h2>
        <p>
          ZENKART est fourni à titre informatif. Les analyses, cotes, estimations de prix et scores sont des
          indicateurs non contractuels. L’utilisateur est responsable des décisions d’achat ou de vente basées sur
          les données du Service.
        </p>
        <p>
          L’éditeur ne peut être tenu responsable des interruptions de service, des erreurs de données ou des
          dommages consécutifs liés à l’utilisation ou l’impossibilité d’utiliser le Service.
        </p>

        <h2>5. Protection des données</h2>
        <p>
          Les données personnelles sont traitées conformément à la politique de confidentialité et au RGPD. Pour plus
          d’informations : <Link to="/confidentialite">politique de confidentialité</Link>.
        </p>

        <h2>6. Conditions générales d’utilisation</h2>
        <p>L’accès et l’utilisation du Service sont régis par nos <Link to="/cgu">conditions générales d’utilisation</Link>.</p>

        <h2>7. Cookies</h2>
        <p>
          Le site utilise des cookies pour améliorer l’expérience utilisateur et analyser le trafic. En continuant à
          naviguer, vous acceptez l’utilisation de cookies. Vous pouvez à tout moment gérer vos préférences via les
          paramètres de votre navigateur.
        </p>

        <h2>8. Liens externes</h2>
        <p>
          ZENKART ne peut être tenu responsable du contenu des sites externes vers lesquels des liens sont proposés.
          Les liens externes sont fournis à titre informatif.
        </p>

        <h2>9. Modification des mentions légales</h2>
        <p>
          L’éditeur se réserve le droit de modifier ces mentions légales à tout moment. Les modifications entrent en
          vigueur dès leur mise en ligne.
        </p>
        <p className="zk-texte-date">Dernière mise à jour : juillet 2026</p>

        <nav className="zk-texte-liens" aria-label="Documents légaux">
          <Link to="/cgu" className="zk-lien">Conditions d’utilisation</Link>
          <Link to="/confidentialite" className="zk-lien">Politique de confidentialité</Link>
          <Link to="/explore" className="zk-lien">Voir les bonnes affaires</Link>
        </nav>
      </div>
    </Page>
  );
}
